(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acm-cart-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.acmCartPageReady) return;
    window.acmCartPageReady = true;

    const rootSelector = '[data-acm-cart-page]';
    const quantityTimers = new Map();
    let requestQueue = Promise.resolve();

    const getRoot = () => document.querySelector(rootSelector);

    const getSectionId = () => {
      const root = getRoot();
      return root ? root.dataset.sectionId : '';
    };

    const getSectionsUrl = () => `${window.location.pathname}${window.location.search}`;

    const getRoutesRoot = () => {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return '/';
    };

    const announce = (message) => {
      const status = document.getElementById('cart-live-region-text');
      if (status) status.textContent = message;
    };

    const showError = (message) => {
      const errorBox = document.getElementById('cart-errors');
      if (errorBox) errorBox.textContent = message;
      announce(message);
    };

    const setBusy = (busy) => {
      const root = getRoot();
      if (!root) return;
      root.classList.toggle('is-updating', busy);
      root.setAttribute('aria-busy', busy ? 'true' : 'false');
    };

    const updateHeaderCount = (count) => {
      document.querySelectorAll('.acm-cart-count').forEach((badge) => {
        badge.textContent = String(count);
        badge.hidden = count < 1;
      });
    };

    const countFromSection = (sectionRoot) => {
      const label = sectionRoot.querySelector('.acm-cart-count-pill');
      if (!label) return 0;
      const match = label.textContent.match(/\d+/);
      return match ? Number(match[0]) : 0;
    };

    const replaceFragment = (currentRoot, nextRoot, selector) => {
      const current = currentRoot.querySelector(selector);
      const next = nextRoot.querySelector(selector);
      if (current && next) current.replaceWith(next);
    };

    const restoreQuantityFocus = (lineKey) => {
      if (!lineKey) return;
      const line = Array.from(document.querySelectorAll('[data-line-key]')).find(
        (item) => item.dataset.lineKey === lineKey
      );
      const input = line && line.querySelector('.acm-cart-quantity__input');
      if (input) input.focus({ preventScroll: true });
    };

    const renderCartSection = (data, focusKey) => {
      const sectionId = getSectionId();
      const sectionHtml = data.sections && data.sections[sectionId];
      if (!sectionHtml) throw new Error('The cart updated, but its new layout could not be loaded.');

      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const nextRoot = parsed.querySelector(rootSelector);
      const currentRoot = getRoot();
      if (!nextRoot || !currentRoot) throw new Error('The cart layout could not be refreshed.');

      const count = countFromSection(nextRoot);
      if (
        nextRoot.classList.contains('acm-cart-page--empty') ||
        currentRoot.classList.contains('acm-cart-page--empty')
      ) {
        currentRoot.replaceWith(nextRoot);
      } else {
        replaceFragment(currentRoot, nextRoot, '.acm-cart-title-row');
        replaceFragment(currentRoot, nextRoot, '.acm-cart-table-card');
        replaceFragment(currentRoot, nextRoot, '[data-acm-summary-totals]');
        replaceFragment(currentRoot, nextRoot, '[data-acm-sticky-total]');
      }

      updateHeaderCount(count);
      restoreQuantityFocus(focusKey);
      announce(`Cart updated. ${count} ${count === 1 ? 'item' : 'items'} in your cart.`);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
    };

    const responseError = async (response) => {
      let message = 'There was an error while updating your cart. Please try again.';
      try {
        const payload = await response.json();
        message = payload.description || payload.message || message;
      } catch (error) {
        return message;
      }
      return message;
    };

    const queueRequest = (task) => {
      requestQueue = requestQueue.catch(() => undefined).then(task);
      return requestQueue;
    };

    const mutateCart = (endpoint, payload, focusKey) =>
      queueRequest(async () => {
        const sectionId = getSectionId();
        if (!sectionId) return;

        setBusy(true);
        showError('');

        try {
          const response = await fetch(`${getRoutesRoot()}cart/${endpoint}.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              ...payload,
              sections: sectionId,
              sections_url: getSectionsUrl()
            })
          });

          if (!response.ok) throw new Error(await responseError(response));
          const data = await response.json();
          renderCartSection(data, focusKey);
        } catch (error) {
          showError(error.message);
        } finally {
          setBusy(false);
        }
      });

    const addProduct = (form) =>
      queueRequest(async () => {
        const sectionId = getSectionId();
        const button = form.querySelector('[data-acm-add-button]');
        if (!sectionId || !button) return;

        const formData = new FormData(form);
        formData.set('sections', sectionId);
        formData.set('sections_url', getSectionsUrl());
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        showError('');

        try {
          const response = await fetch(`${getRoutesRoot()}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body: formData
          });

          if (!response.ok) throw new Error(await responseError(response));
          const data = await response.json();
          renderCartSection(data);
        } catch (error) {
          showError(error.message);
        } finally {
          if (button.isConnected) {
            button.removeAttribute('aria-busy');
            button.disabled = false;
          }
        }
      });

    const scheduleQuantityUpdate = (input) => {
      const line = input.closest('[data-line-key]');
      if (!line) return;

      const lineKey = line.dataset.lineKey;
      const quantity = Math.max(0, Number(input.value) || 0);
      window.clearTimeout(quantityTimers.get(lineKey));
      quantityTimers.set(
        lineKey,
        window.setTimeout(() => {
          quantityTimers.delete(lineKey);
          mutateCart('change', { id: lineKey, quantity }, lineKey);
        }, 180)
      );
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches(`${rootSelector} .acm-cart-quantity__input`)) return;
      scheduleQuantityUpdate(event.target);
    });

    document.addEventListener('submit', (event) => {
      const addForm = event.target.closest(`${rootSelector} [data-acm-add-form]`);
      if (addForm) {
        event.preventDefault();
        addProduct(addForm);
        return;
      }

      if (event.target.id !== 'cart') return;
      const submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') return;

      event.preventDefault();
      const promoButton = submitter && submitter.classList.contains('acm-cart-promo__button');
      if (promoButton) {
        const discount = document.getElementById('AcmCartDiscount');
        mutateCart('update', { discount: discount ? discount.value.trim() : '' });
        return;
      }

      const updates = {};
      document.querySelectorAll(`${rootSelector} [data-line-key]`).forEach((line) => {
        const input = line.querySelector('.acm-cart-quantity__input');
        if (input) updates[line.dataset.lineKey] = Math.max(0, Number(input.value) || 0);
      });
      mutateCart('update', { updates });
    });

    document.addEventListener('click', (event) => {
      const root = event.target.closest(rootSelector);
      if (!root) return;

      const toggle = event.target.closest('[data-acm-cart-summary-toggle]');
      if (toggle) {
        const summary = toggle.closest('.acm-cart-summary');
        const collapsed = summary.getAttribute('data-collapsed') === 'true';
        summary.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
        return;
      }

      const remove = event.target.closest('.acm-cart-remove');
      if (remove) {
        const line = remove.closest('[data-line-key]');
        if (!line) return;
        event.preventDefault();
        mutateCart('change', { id: line.dataset.lineKey, quantity: 0 });
        return;
      }

      const minus = event.target.closest('[data-acm-cart-minus]');
      const plus = event.target.closest('[data-acm-cart-plus]');
      if (!minus && !plus) return;

      event.preventDefault();
      const quantity = event.target.closest('.acm-cart-qty');
      const input = quantity && quantity.querySelector('.acm-cart-quantity__input');
      if (!input) return;

      const step = Number(input.step) || 1;
      const min = Number(input.min) || 0;
      const max = input.max ? Number(input.max) : Infinity;
      const current = Number(input.value) || 0;
      const next = plus ? current + step : current - step;
      input.value = String(Math.max(min, Math.min(max, next)));
      scheduleQuantityUpdate(input);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acm-premium-header"]) return;
  try {
    
  if (!customElements.get('acm-premium-header')) {
    class ACMPremiumHeader extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('.acm-mobile-drawer');
        this.openButton = this.querySelector('.acm-mobile-menu-button');
        this.closeButton = this.querySelector('.acm-mobile-drawer__close');
        this.mobileSearchButton = this.querySelector('.acm-mobile-search-button');
        this.mobileSearch = this.querySelector('.acm-search--mobile input[type="search"]');
        this.desktopDetails = Array.from(this.querySelectorAll('.acm-main-nav details'));
        this.handleScroll = this.handleScroll.bind(this);
        this.openDrawer = this.openDrawer.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);

        this.openButton?.addEventListener('click', this.openDrawer);
        this.closeButton?.addEventListener('click', this.closeDrawer);
        this.mobileSearchButton?.addEventListener('click', () => this.mobileSearch?.focus());
        this.drawer?.addEventListener('click', (event) => {
          if (event.target === this.drawer || event.target.closest('a')) this.closeDrawer();
        });
        document.addEventListener('click', this.handleDocumentClick);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll);
        this.handleScroll();
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener('click', this.openDrawer);
        this.closeButton?.removeEventListener('click', this.closeDrawer);
        document.removeEventListener('click', this.handleDocumentClick);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
      }

      handleScroll() {
        if (this.scrollTicking) return;
        this.scrollTicking = true;

        window.requestAnimationFrame(() => {
          if (window.innerWidth < 1100) {
            this.classList.remove('is-compact');
          } else if (this.classList.contains('is-compact')) {
            if (window.scrollY < 110) this.classList.remove('is-compact');
          } else if (window.scrollY > 180) {
            this.classList.add('is-compact');
          }

          this.scrollTicking = false;
        });
      }

      openDrawer() {
        if (!this.drawer) return;
        if (typeof this.drawer.showModal === 'function') {
          this.drawer.showModal();
        } else {
          this.drawer.setAttribute('open', '');
        }
        this.openButton?.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        this.closeButton?.focus();
      }

      closeDrawer() {
        if (!this.drawer?.open) return;
        if (typeof this.drawer.close === 'function') {
          this.drawer.close();
        } else {
          this.drawer.removeAttribute('open');
        }
        this.openButton?.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        this.openButton?.focus();
      }

      handleDocumentClick(event) {
        this.desktopDetails.forEach((details) => {
          if (details.open && !details.contains(event.target)) details.removeAttribute('open');
        });
      }

    }

    customElements.define('acm-premium-header', ACMPremiumHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acm-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-acm-recently-viewed]');
    if (!sections.length) return;

    const storageKeys = [
      'acmRecentlyViewed',
      'recentlyViewed',
      'recentlyViewedProducts',
      'recently-viewed-products'
    ];

    const toHandle = (item) => {
      if (typeof item === 'string') {
        const match = item.match(/\/products\/([^/?#]+)/);
        return match ? match[1] : item;
      }
      if (!item || typeof item !== 'object') return '';
      if (item.handle) return item.handle;
      if (item.productHandle) return item.productHandle;
      if (item.url) {
        const match = String(item.url).match(/\/products\/([^/?#]+)/);
        return match ? match[1] : '';
      }
      return '';
    };

    const getHandles = () => {
      for (const key of storageKeys) {
        const raw = window.localStorage.getItem(key);
        if (!raw) continue;
        let parsed;
        try {
          parsed = JSON.parse(raw);
        } catch {
          parsed = raw.split(',');
        }
        if (!Array.isArray(parsed)) parsed = [parsed];
        const handles = parsed
          .map(toHandle)
          .filter((handle) => /^[a-z0-9][a-z0-9-]*$/i.test(handle));
        if (handles.length) return [...new Set(handles)];
      }
      return [];
    };

    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency
      }).format(Number(cents || 0) / 100);
    };

    const createCard = (product) => {
      const link = document.createElement('a');
      link.className = 'acm-recently-viewed__card';
      link.href = product.url;
      link.setAttribute('role', 'listitem');

      if (product.featured_image) {
        const image = document.createElement('img');
        image.className = 'acm-recently-viewed__image';
        image.src = product.featured_image;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 176;
        image.height = 176;
        link.append(image);
      }

      const body = document.createElement('span');
      body.className = 'acm-recently-viewed__body';

      const title = document.createElement('span');
      title.className = 'acm-recently-viewed__title';
      title.textContent = product.title;

      const price = document.createElement('span');
      price.className = 'acm-recently-viewed__price';
      price.textContent = formatMoney(product.price);

      body.append(title, price);
      link.append(body);
      return link;
    };

    const handles = getHandles();
    if (!handles.length) return;

    sections.forEach(async (section) => {
      const limit = Number(section.dataset.limit || 5);
      const list = section.querySelector('[data-acm-recently-viewed-list]');
      const root = window.Shopify?.routes?.root || '/';
      const products = await Promise.all(
        handles.slice(0, limit).map(async (handle) => {
          try {
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
              headers: { Accept: 'application/json' }
            });
            if (!response.ok) return null;
            return response.json();
          } catch {
            return null;
          }
        })
      );

      products.filter(Boolean).forEach((product) => list.append(createCard(product)));
      if (list.children.length) section.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-product-features"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('blocky-slider-1')) {
  customElements.define('blocky-slider-1',
    class BlockySlider1 extends HTMLElement {
      constructor() {
        super()

        let nextButton = this.querySelector('#next');
        let prevButton = this.querySelector('#prev');
        
        nextButton.addEventListener("click", () => {
            this.showSlider('next');
        })
        prevButton.addEventListener("click", () => {
            this.showSlider('prev');
        })
      }

      showSlider(type) {      
        let listHTML = this.querySelector('.blocky-slider-container');

        this.classList.remove('next', 'prev');
        let items = this.querySelectorAll('.slide');
        if(type === 'next'){
          listHTML.appendChild(items[0]);
          this.classList.add('next');          
        } else{
          listHTML.prepend(items[items.length - 1]);
          this.classList.add('prev');
        }
      }
    }
  )
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-header-section"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hcg-main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const syncQuantity = (root) => {
      const input = root.querySelector('[data-hcg-quantity-input]');
      const productInfo = root.closest('product-info');
      const form = productInfo?.querySelector('form[data-type="add-to-cart-form"]');
      if (!input || !form) return;

      let formQuantity = form.querySelector('input[name="quantity"]');
      if (!formQuantity) {
        formQuantity = document.createElement('input');
        formQuantity.type = 'hidden';
        formQuantity.name = 'quantity';
        form.appendChild(formQuantity);
      }
      formQuantity.value = Math.max(1, Number.parseInt(input.value, 10) || 1);
    };

    const selectTier = (radio) => {
      const root = radio.closest('[data-hcg-quantity-root]');
      if (!root) return;
      root.querySelectorAll('.hcg-tier').forEach((tier) => tier.classList.remove('is-selected'));
      radio.closest('.hcg-tier')?.classList.add('is-selected');
      const input = root.querySelector('[data-hcg-quantity-input]');
      if (input) input.value = radio.dataset.tierQuantity || radio.value || 1;
      syncQuantity(root);
    };

    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-tier-quantity]')) {
        selectTier(event.target);
      }
      if (event.target.matches('[data-hcg-quantity-input]')) {
        syncQuantity(event.target.closest('[data-hcg-quantity-root]'));
      }
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-hcg-quantity-minus], [data-hcg-quantity-plus]');
      if (!button) return;
      const root = button.closest('[data-hcg-quantity-root]');
      const input = root?.querySelector('[data-hcg-quantity-input]');
      if (!input) return;
      const step = Number.parseInt(input.step, 10) || 1;
      const minimum = Number.parseInt(input.min, 10) || 1;
      const current = Number.parseInt(input.value, 10) || minimum;
      input.value = button.hasAttribute('data-hcg-quantity-plus')
        ? current + step
        : Math.max(minimum, current - step);
      root.querySelectorAll('.hcg-tier').forEach((tier) => tier.classList.remove('is-selected'));
      syncQuantity(root);
    });

    document.addEventListener(
      'submit',
      (event) => {
        const productInfo = event.target.closest('product-info');
        const root = productInfo?.querySelector('[data-hcg-quantity-root]');
        if (root) syncQuantity(root);
      },
      true
    );

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-hcg-quantity-root]').forEach(syncQuantity);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  const activateHcgProductTab = (section, target) => {
    if (!section) return;
    const reviewPanel = section.querySelector('[data-hcg-review-panel]');
    const isReviews = target === 'reviews';

    section.classList.toggle('is-reviews-active', isReviews);
    section.querySelectorAll('[data-hcg-tab]').forEach((tab) => {
      tab.setAttribute('aria-selected', String(tab.dataset.hcgTab === target));
    });
    section.querySelectorAll('[data-hcg-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.hcgPanel !== target;
    });
    if (reviewPanel) reviewPanel.hidden = !isReviews;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hcg-tab]');
    if (button) {
      const section = button.closest('.hcg-details');
      activateHcgProductTab(section, button.dataset.hcgTab);
      return;
    }

    const reviewLink = event.target.closest('[data-hcg-open-reviews]');
    if (!reviewLink) return;
    const section = document.querySelector('.hcg-details');
    const reviewPanel = section?.querySelector('[data-hcg-review-panel]');
    if (!section || !reviewPanel) return;
    event.preventDefault();
    activateHcgProductTab(section, 'reviews');
    reviewPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hcg-related-previous], [data-hcg-related-next]');
    if (!button) return;
    const section = button.closest('.hcg-related');
    const track = section?.querySelector('[data-hcg-related-track]');
    if (!track) return;
    const card = track.querySelector('.hcg-related__item');
    const amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    track.scrollBy({
      left: button.hasAttribute('data-hcg-related-next') ? amount : -amount,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();
})();
